import { UAParser } from 'ua-parser-js';

export class Browser {

	static nameAndVersion() {
		const { browser } = UAParser(window.navigator.userAgent);
		return browser.name + ' ' + browser.major;
	}

	static name() {
		return UAParser(window.navigator.userAgent).browser.name;
	}

	static os() {
		return UAParser(window.navigator.userAgent).os.name;
	}

	static isMobile() {
		return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
	}

	static userAgent() {
		return window.navigator.userAgent;
	}
}
